import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import PharmacyForm from './PharmacyForm';

const PharmacyModal = ({ show, onHide, pharmacyid, edittrigger, onCallParent }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {pharmacyid ? 'Edit Pharmacy' : 'Add Pharmacy'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-body-tertiary p-4">
                <PharmacyForm
                    edittrigger={edittrigger}
                    onCallParent={() => {
                        if (onCallParent) onCallParent();
                        onHide();
                    }}
                    pharmacyid={pharmacyid}
                />
            </Modal.Body>
        </Modal>
    );
};

PharmacyModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    pharmacyid: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default PharmacyModal;

